import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Configuration} from '@shared/models/configuration';
import {Subject} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {takeUntil} from 'rxjs/operators';
import {getVirtualGridItems} from '@shared/store/selectors/virtual-grid.selector';
import {IVirtualGridCollectionState} from '@shared/store/reducers/virtual-grid.reducer';
import {FileManagementService} from '@core/services/file-management.service';
import {
  DownloadFilingFormErrorReportDownloadCommand, FilingManagerDownloadFilingFormErrorReportDownloadCommand,
  SpreadsheetDownloadFilingFormErrorReportDownloadCommand
} from '../../commands/dac6-reporter.command';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {Api} from "@shared/constants/common-field.constants";
import {QueryProvider} from "@shared/queries/query-provider";
@Component({
    standalone: false,
    selector: 'particle-filing-error-report',
  templateUrl: './filing-error-report.component.html',
  styleUrls: ['./filing-error-report.component.scss']
})
export class FilingErrorReportComponent implements OnInit, OnDestroy {
  sourceKey = 'Form-View-Validation-Error';
  targetApi: any;
  invalidateSubject = new InvalidateSubject();
  recordCount = 0;
  rightElementsCount: any;
  countryCode: any;
  downloadText: any;
  ngUnsubscribe = new Subject<void>();
  gridParams: any;
  constructor(private store: Store<IVirtualGridCollectionState>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private fuseSplashScreenService: FuseSplashScreenService,
              protected commandService: CommandService,
              private snackBarService: SnackBarService,
              private fileManagementService: FileManagementService,
              public dialogRef: MatDialogRef<FilingErrorReportComponent>) { }

  ngOnInit() {
    this.countryCode = this.data.countryCode;
    if (this.data.rightElementsCount) {
      this.rightElementsCount = this.data.rightElementsCount;
      this.setDownloadText();
    }
    this.targetApi = this.data.targetApi;
    this.sourceKey = this.getValidationErrorSourceKey(this.targetApi);
    const config = Configuration.getSmartGridConfig(this.sourceKey);
    config.Parameters['FORM_ID'] = this.data.formId;
    config.Parameters['FORMS_SELECTION_FILTER_ID'] = this.data.exectionId;
    this.gridParams = config.Parameters;
    this.store.pipe(select(getVirtualGridItems, this.sourceKey), takeUntil(this.ngUnsubscribe)).subscribe((items: any) => {
      if (items && items.length) {
        this.recordCount = items[0].cells['Order'].value;
      }
    });

  }

  getValidationErrorSourceKey(api: string){
    switch (api) {
      case Api.Spreadsheet:
        return 'Scenario-Form-View-Validation-Error';
      case Api.FilingManagerApi:
        let c = Configuration.getSmartGridConfig('Scenario-Form-View-Validation-Error');
        c.RootUrlKey = Api.FilingManagerApi;
        let k = 'FilingManager-Form-View-Validation-Error';
        Configuration.setSmartGridConfig(k, c);
        return k;
      default :
        return 'Form-View-Validation-Error';
    }
  }

  errorAction(action: string) {
    if (action === 'download-error') {
      this.downloadErrorReport();
    } else {
      this.dialogRef.close(action);
    }
  }
  onRecordCountChange(event) {
    // this.recordCount = event;
  }
  onCancel() {
    this.dialogRef.close();
  }
  downloadErrorReport() {
    let errorReportDownloadCommand = this.getErrorReportDownloadCommand(this.targetApi);
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(errorReportDownloadCommand).pipe(takeUntil(this.ngUnsubscribe)).subscribe((commandState: any) => {
      if (commandState && !commandState.Payload.IsOption) {
        this.fileManagementService.downloadClientFileWithId(commandState.Payload.FileId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(response => {
          if (response) {
            this.fileManagementService.openSaveFileWindow(response, commandState.Payload.FileName);
            this.fuseSplashScreenService.hide();
            this.snackBarService.showInformation('File Downloaded');
          }
        });
      }
      if (commandState && commandState.Payload.IsOption) {
        this.fuseSplashScreenService.hide();
        this.snackBarService.showError(commandState.Payload.Message);
      }
    }, error => {
      this.fuseSplashScreenService.hide();
      console.log(error);
    });
  }

  private getErrorReportDownloadCommand(api: string) {
    let errorReportDownloadCommand;
    switch (api) {
      case Api.Spreadsheet:
        errorReportDownloadCommand = new SpreadsheetDownloadFilingFormErrorReportDownloadCommand(this.data.formId);
        break;
      case Api.FilingManagerApi:
        errorReportDownloadCommand = new FilingManagerDownloadFilingFormErrorReportDownloadCommand(this.data.formId);
        break;
      default :
        errorReportDownloadCommand = new DownloadFilingFormErrorReportDownloadCommand(this.data.formId);
        break;
    }
    return errorReportDownloadCommand;
  }

  onGridCellValueChange($event: any) {

  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private setDownloadText() {
    switch (this.countryCode) {
      case 'NL':
        if ( this.rightElementsCount == 1 ) { this.downloadText = 'Download Form(.xml)'; } else { this.downloadText = 'Download Forms(.xml)'; }
        break;
      case 'PL':
        if ( this.rightElementsCount == 1 ) { this.downloadText = 'Download Form(.zip)'; } else { this.downloadText = 'Download Forms(.zip)'; }
        break;
      default:
        if ( this.rightElementsCount == 1 ) { this.downloadText = 'Download Form(.xml)'; } else { this.downloadText = 'Download Forms(.zip)'; }
        break;
    }
  }
}
